export class ProductionPlanModel {
    productionPlanId: string;
    country: string;
    season: string;
    businessUnit: string;
    styleNo: string;
    phase: string;
    whDate: Date;
    contractDate: Date;
    exfDate: Date;
    fabOqyt: number;
    trimOqty: number;
    poOqty: number;
    fabRequestDate: Date;
    fabricAnswerDate: Date;
    fabricActualDate: Date;
    trimAnswerDate: Date;
    trimRequestDate: Date;
    trimActualDate: Date;
    poAnswerDate: Date;
    poRequestDate: Date;
    poActualDate: Date;
    createdAt: string;
    createdUser: string | null;
    updatedAt: string;
    updatedUser: string | null;
    versionFlag: number;
    isActive: boolean;
    companyCode: string;
    unitCode: string;
    sam: number;
    keisu: number;
    samMaster: number;
    fabBodyConsumption: number;
    fabBodyRequirement: number;
    fabConsumptionWithTrims: number;
    fabRequirementWithTrims: number;
    itemName: string;
    mainSampleCode: string;
    productionPlanTypeName: string;;
    trimOrderNo: string;
    fabricOrderNo: string;
    poOrderNo: string;
    productionMonth: string;

    constructor(
        productionPlanId: string,
        country: string,
        season: string,
        businessUnit: string,
        styleNo: string,
        phase: string,
        whDate: Date,
        contractDate: Date,
        exfDate: Date,
        fabOqyt: number,
        trimOqty: number,
        poOqty: number,
        fabRequestDate: Date,
        fabricAnswerDate: Date,
        fabricActualDate: Date,
        trimAnswerDate: Date,
        trimRequestDate: Date,
        trimActualDate: Date,
        poAnswerDate: Date,
        poRequestDate: Date,
        poActualDate: Date,
        createdAt: string,
        createdUser: string | null,
        updatedAt: string,
        updatedUser: string | null,
        versionFlag: number,
        isActive: boolean,
        companyCode: string,
        unitCode: string,
        sam: number,
        keisu: number,
        samMaster: number,
        fabBodyConsumption: number,
        fabBodyRequirement: number,
        fabConsumptionWithTrims: number,
        fabRequirementWithTrims: number,
        itemName: string,
        mainSampleCode: string,
        productionPlanTypeName: string,
        trimOrderNo: string,
        fabricOrderNo: string,
        poOrderNo: string,
        productionMonth: string
    ) {
        this.productionPlanId = productionPlanId;
        this.country = country;
        this.season = season;
        this.businessUnit = businessUnit;
        this.styleNo = styleNo;
        this.phase = phase;
        this.whDate = whDate;
        this.contractDate = contractDate;
        this.exfDate = exfDate;
        this.fabOqyt = fabOqyt;
        this.trimOqty = trimOqty;
        this.poOqty = poOqty;
        this.fabRequestDate = fabRequestDate;
        this.fabricAnswerDate = fabricAnswerDate;
        this.fabricActualDate = fabricActualDate;
        this.trimAnswerDate = trimAnswerDate;
        this.trimRequestDate = trimRequestDate;
        this.trimActualDate = trimActualDate;
        this.poAnswerDate = poAnswerDate;
        this.poRequestDate = poRequestDate;
        this.poActualDate = poActualDate;
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.updatedAt = updatedAt;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
        this.isActive = isActive;
        this.companyCode = companyCode;
        this.unitCode = unitCode;
        this.sam = sam;
        this.keisu = keisu;
        this.samMaster = samMaster;
        this.fabBodyConsumption = fabBodyConsumption;
        this.fabBodyRequirement = fabBodyRequirement;
        this.fabConsumptionWithTrims = fabConsumptionWithTrims;
        this.fabRequirementWithTrims = fabRequirementWithTrims;
        this.itemName = itemName;
        this.mainSampleCode = mainSampleCode;
        this.productionPlanTypeName = productionPlanTypeName;
        this.trimOrderNo = trimOrderNo;
        this.fabricOrderNo = fabricOrderNo;
        this.poOrderNo = poOrderNo;
        this.productionMonth = productionMonth;
    }
}
